import { Toaster as Sonner, toast } from "sonner";
import { messageOf } from "@/api/problem";
import { useTheme } from "@/lib/theme";

export function Toaster() {
  const { resolved } = useTheme();
  return <Sonner theme={resolved} position="bottom-right" richColors closeButton toastOptions={{ duration: 6000 }} />;
}

/** Shows a refusal of the API (or any error) in plain words. */
export function toastError(e: unknown, title?: string): void {
  if (title) toast.error(title, { description: messageOf(e), duration: 9000 });
  else toast.error(messageOf(e), { duration: 9000 });
}

export { toast };
